import React from "react";
import { motion } from "framer-motion";

const letters = "FRE3BRD".split("");

export default function Preloader({ onDone }) {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black"
      initial={{ opacity: 1 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="overflow-hidden">
        <motion.div
          className="flex items-baseline gap-[0.02em] font-display font-black text-white text-5xl sm:text-7xl md:text-8xl tracking-tighter"
          initial="hidden"
          animate="visible"
          onAnimationComplete={() => {
            setTimeout(onDone, 500);
          }}
          variants={{
            visible: { transition: { staggerChildren: 0.06, delayChildren: 0.15 } },
          }}
        >
          {letters.map((l, i) => (
            <span key={i} className="overflow-hidden inline-block">
              <motion.span
                className="inline-block"
                variants={{
                  hidden: { y: "110%" },
                  visible: {
                    y: "0%",
                    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
                  },
                }}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </motion.div>
      </div>
      <motion.div
        className="absolute bottom-10 left-0 right-0 mx-auto w-[180px] h-[1px] bg-white/15 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.div
          className="h-full bg-white"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.6, ease: "easeInOut" }}
        />
      </motion.div>
    </motion.div>
  );
}
